import React from 'react';

import Proptypes from 'prop-types';

import { FieldInput } from '../../../../../../../form/fields';

const ShippmentTrackingNumber = ({
  shippmentTrackingNumber,
  setShippmentTrackingNumber
}) => {
  return (
    <div style={{ marginTop: '-2rem' }}>
      <FieldInput
        data={{
          value: shippmentTrackingNumber,
          placeholder: 'shippment tracking #...',
          label: 'Shippment tracking #',
          onChange: date => {
            setShippmentTrackingNumber(date.target.value);
          },
          name: 'iotShippmentTrackingNumber',
          required: false,
          readonly: false,
          tooltip: ''
        }}
      />
    </div>
  );
};

ShippmentTrackingNumber.propTypes = {
  shippmentTrackingNumber: Proptypes.string.isRequired,
  setShippmentTrackingNumber: Proptypes.func.isRequired
};

export default ShippmentTrackingNumber;
